'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function getBackgroundColor({ color, theme }) {
    switch (color) {
        case 'primary':
            return theme.colors.primary.normal;
        case 'success':
            return theme.colors.success.normal;
        case 'warning':
            return theme.colors.warning.normal;
        case 'danger':
            return theme.colors.danger.normal;
        case 'grey':
            return theme.colors.disabled.text;
        case 'dark':
        default:
            return theme.colors.body.text;
    }
}
const PillStyled = styled__default.default.span `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${getBackgroundColor};
`;
const PillContainer = styled__default.default.div `
  display: inline-flex;
  justify-content: center;
  width: 20px;
`;

exports.PillContainer = PillContainer;
exports.PillStyled = PillStyled;
//# sourceMappingURL=pill.styles.js.map
